module.exports = __webpack_public_path__ + "static/logo-9577dfc08e6868da4dc650d6db7f6df5.png";